import { Injectable } from '@angular/core';
import { fillArr, getQueryParams } from '@pin-up-global/common';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { ApiService, ListResponse } from '@shared/abstraction';
import { delay, Observable, of } from 'rxjs';
import {
  FlowContentItem,
  FlowContentItemTranslationStatistics,
  FlowsLocalsReq,
  GetTranslationsStatisticsReq,
  PatchFlowContentReq,
} from './flows-localization.abstraction';

@Injectable({ providedIn: 'root' })
export class FlowsLocalizationApiServiceMock extends ApiService {
  isLoading$ = this._isLoading$;

  getTranslationsStatistics(params: GetTranslationsStatisticsReq): Observable<FlowContentItemTranslationStatistics> {
    return of({
      reviewRequiredCount: 8,
      emptyValuesCount: 2,
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$)
    );
  }

  patchTranslation(params: PatchFlowContentReq): Observable<boolean> {
    return of(true).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$)
    );
  }

  getFlowContent(params: FlowsLocalsReq): Observable<ListResponse<FlowContentItem>> {
    return of({
      items: fillArr(10, (id) => ({
        id,
        value: 'Flow',
        translations: [
          {
            id: 1,
            value: 'Ukrainian lang',
            localeId: 5,
            reviewRequired: true,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          },
          {
            id: 2,
            value: 'Russian lang',
            localeId: 2,
            reviewRequired: true,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          },
          {
            id: 3,
            value: 'Engl',
            localeId: 1,
            reviewRequired: false,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          },
        ],
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      })),
      count: 100,
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$)
    );
  }
}
